import { render, staticRenderFns } from "./Platform-Account.vue?vue&type=template&id=01e706ba&scoped=true&"
import script from "./Platform-Account.vue?vue&type=script&lang=js&"
export * from "./Platform-Account.vue?vue&type=script&lang=js&"
import style0 from "./Platform-Account.vue?vue&type=style&index=0&id=01e706ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e706ba",
  null
  
)

export default component.exports